export function setCoachingTracks(state, payload) {
    state.coachingTracks = payload
}
export function setActiveCT(state, payload) {
    state.activeCT = payload
}
export function setTimelines(state, payload) {
    state.timelines = payload
}
export function resetStore(state) {
    // state.coachingTracks = []
    // state.timeline = []
}

export function showAndHideCreatePostDialog(state, payload) {
    state.createPostDialog = payload
}

export function showAndHideEditPostDialog(state, payload) {
    state.editPostDialog = payload
}

export function showAndHideSharePostDialog(state, payload) {
    state.sharePostDialog = payload
}

export function setTimeline(state, payload) {
    state.timeline = payload
}

export function setTaggableUsers(state, users) {
    state.taggableUsers = users;
}

export function setCoacheeActionItems(state, payload) {
    state.coacheeViewActionItems = payload
}

export function setCoachActionItems(state, payload) {
    state.coachViewActionItems = payload
}

// export function pushCoachingTrack(state, payload) {
//     console.log('pushCoachingTrack', payload)
//     state.timelines.data.push({ content: payload })
// }

export function setLastUpdated(state) {
    state.lastUpdated = new Date().getTime()
}
